module.exports = __webpack_public_path__ + "img/icon_month.92116b91.svg";